import {Card, CardContent, Chip, Stack, Typography} from '@mui/material';
import {SeedQuestion, SeedQuestionSource, SeedQuestionStatus} from '@cp/model';
import MarkdownContentRenderer from '../../../atoms/MarkdownContentRenderer/MarkdownContentRenderer';
import {env} from '../../../config/env';

const sourceColors: Record<SeedQuestionSource, string> = {
  [SeedQuestionSource.OAK]: '#90BE6D',
  [SeedQuestionSource.MANUAL]: '#1B263B',
  [SeedQuestionSource.GPT]: '#4A90E2',
};

export interface AdminSeedQuestionListItemProps {
  seedQuestion: SeedQuestion;
  onClick: (seedQuestion: SeedQuestion) => void;
}

export default function AdminSeedQuestionListItem({seedQuestion, onClick}: AdminSeedQuestionListItemProps) {
  return (
    <Card
      sx={{
        cursor: 'pointer',
        '&:hover': {bgcolor: '#f5f5f5'},
        border: '1px solid #e0e0e0',
      }}
      onClick={() => onClick(seedQuestion)}
    >
      <CardContent>
        <Stack direction="column" spacing={1}>
          <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
            <Chip label={seedQuestion.topic} size="small" sx={{bgcolor: '#e3f2fd', color: '#1976d2'}} />
            <Chip
              label={seedQuestion.source}
              size="small"
              sx={{
                bgcolor: sourceColors[seedQuestion.source] || '#666',
                color: 'white',
              }}
            />
            <Chip
              label={seedQuestion.status}
              size="small"
              sx={{
                bgcolor: env.seedQuestion.status[seedQuestion.status || SeedQuestionStatus.ACTIVE].color,
                color: 'white',
              }}
            />
          </Stack>
          <MarkdownContentRenderer content={seedQuestion.questionText} />
          <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1}>
            <Typography variant="body2" sx={{color: '#666'}}>
              {seedQuestion.options?.length || 0} options • Created:{' '}
              {new Date(seedQuestion.createdAt).toLocaleDateString()}
            </Typography>
            <Typography variant="body2" sx={{color: '#666'}}>
              Answer: {seedQuestion.answer}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
